import { render, staticRenderFns } from "./CourseOverviewGeneralInfo.vue?vue&type=template&id=3a7d62e0&scoped=true"
import script from "./CourseOverviewGeneralInfo.vue?vue&type=script&lang=js"
export * from "./CourseOverviewGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./CourseOverviewGeneralInfo.vue?vue&type=style&index=0&id=3a7d62e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d62e0",
  null
  
)

export default component.exports